import React, { useMemo, useState, useEffect } from "react";
import { ToolTip } from "../../../../../Library/Overlays";
import { Select2CPMK, Select2TypeCom } from "./_ui_forms";
import { EncodeURIComponentSafe } from "../../../../../Library/GlobalHelper";
import { openModal, PopUpMessage } from "../../../../../Library/ModalPopUp";
import { MessageFailedScore } from "../ScoringComponents";
import { CREATE_APPEND_SECTION_COM, CREATE_APPEND_SECTION_COM2 } from "./_hooks";

export function FormCom({
  section_id,
  components,
  HandlerBack,
  section_cpmk,
  type_com,
  HandlerProgressBar,
}) {
  let message_required = [];
  if (section_cpmk && Object.values(section_cpmk).length === 0) {
    message_required.push("❌ This course has no CPMK. Please add CPMK first.");
  }
  const obj_default_type = {
    id: Date.now(),
    name: `Assessment Instrument 1`,
    topic: "",
    type: {
      value: "",
      label: "",
      desc: "",
    },
    cpmk: [],
    weight: 0,
    ori: false,
    item_com_old: false
  };
  const [my_comp, setMy_comp] = useState([]);
  const [old_comp, setOld_comp] = useState([]);

  useEffect(() => {
    if (components && components.length > 0) {
      const comp_old = components.some((com) => com?.wg_com?.type === "Formative" || com?.wg_com?.type === "Summative");
      let computedData = components;
      if (comp_old) {
        computedData = components.sort((a, b) => (a.wg_com_id > b.wg_com_id ? 1 : -1));
      } else {
        computedData = components.sort((a, b) => {
          if (b.id < a.id) return 1;
          if (b.id > a.id) return -1;

          return a.id - b.id;
        });
      }
      const newComponents = computedData.map((com, index) => {
        const check_comp_old = (com?.wg_com?.type === "Formative" || com?.wg_com?.type === "Summative") ? true : false;
        return {
          id: com?.id || 0,
          name: check_comp_old ? com?.name : `Assessment Instrument ${index + 1}`,
          topic: com?.topic || com?.name,
          type: {
            value: com?.wg_com?.type || "",
            label: com?.wg_com?.name || "",
            desc: com?.wg_com?.desc || "",
            id: com?.wg_com?.id || "",
          },
          cpmk: com?.section_com_obe?.map((obe) => obe?.section_obe_id) || [],
          weight: com?.weight,
          wg_com_id: com?.wg_com_id || 0,
          ori: true,
          item_com_old: check_comp_old
        };
      });
      // console.log("newComponents_", newComponents);
      setMy_comp(newComponents)
    } else {
      setMy_comp([obj_default_type]);
    }
  }, [components]);

  const TotalWeight = useMemo(() => {
    const tWeight = my_comp.reduce((acc, obj) => acc + obj.weight, 0);
    return tWeight;
  }, [my_comp]);

  if (TotalWeight !== 100) {
    message_required.push(
      `❌Total weight (${TotalWeight.toFixed(0)}%) is ${TotalWeight < 100 ? "less than" : "over"} 100%, please update the weights of assessment`,
    );
  }

  const [supmit, setsupmit] = useState({
    loading: false,
    data: [],
    message: "",
  });

  // Handler untuk add new component (langsung ke list)
  const handleAddNewComponent = () => {
    const newComponent = {
      id: Date.now(),
      name: `Assessment Instrument ${my_comp.length + 1}`,
      topic: "",
      type: "",
      cpmk: [],
      weight: 0,
      ori: false,
      item_com_old: false
    };
    setMy_comp([...my_comp, newComponent]);
  };

  // Handler untuk update component di list
  const handleUpdateComponent = (id, field, value) => {
    setMy_comp((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)),
    );
  };

  // Handler untuk remove component
  const handleRemoveComponent = (id) => {
    setMy_comp(my_comp.filter((item) => item.id !== id));
    openModal({ open: false });
  };

  const hasEmptyFields = useMemo(() => {
    const result = my_comp.some(
      (comp) =>
        !comp.topic ||
        !comp.type ||
        comp.cpmk.length === 0 ||
        comp.weight <= 0,
    );
    return result;
  }, [my_comp]);

  if (hasEmptyFields) {
    message_required.push(
      `❌ Please fill in all required fields for each assessment.`,
    );
  }

  const hasUnusedCPMK = useMemo(() => {
    const allCPMKIds = section_cpmk.map((cpmk) => cpmk.id);
    const usedCPMKIds = my_comp.flatMap((comp) => comp.cpmk);
    const unusedCPMKs = allCPMKIds.filter((id) => !usedCPMKIds.includes(id));
    return unusedCPMKs.length > 0 ? unusedCPMKs : false;
  }, [my_comp, section_cpmk]);

  if (hasUnusedCPMK && hasUnusedCPMK.length > 0) {
    const unusedCPMKCodes = section_cpmk
      .filter((cpmk) => hasUnusedCPMK.includes(cpmk.id))
      .map((cpmk) => cpmk.cpmk?.code || cpmk.id);
    if (unusedCPMKCodes && Object.values(unusedCPMKCodes).length > 0) {
      const unused_list = unusedCPMKCodes.join(", ");

      message_required.push(
        `❌ Not all CPMKs are used in assessment. Unused CPMK: ${unused_list}`,
      );
    }
  }

  // Handler untuk save semua changes ke backend
  const handleSaveChanges = async () => {
    if (hasEmptyFields) {
      openModal({
        message: (
          <PopUpMessage
            title={"Required field"}
            message={`Please fill all fields for each assessment`}
            type={`error`}
          />
        ),
      });
      return;
    }
    if (hasUnusedCPMK && hasUnusedCPMK.length > 0) {
      const unusedCPMKCodes = section_cpmk
        .filter((cpmk) => hasUnusedCPMK.includes(cpmk.section_obe_id))
        .map((cpmk) => cpmk.obe?.code || cpmk.section_obe_id)
        .join(", ");

      openModal({
        message: (
          <PopUpMessage
            title={"Incomplete CPMK Coverage"}
            message={`All CPMKs must be used in at least one assessment. Unused CPMK: ${unusedCPMKCodes}`}
            type={`error`}
          />
        ),
      });
      return;
    }

    try {
      setsupmit({
        loading: true,
        data: [],
        message: "",
      });
      const param_append = {
        component: my_comp.map((comp) => {
          console.log(comp?.type);
          const typeValue =
            typeof comp.type === "object" ? comp.type.value : comp.type;
          const cpmkCount = comp.cpmk.length;
          const weightPerCPMK = cpmkCount > 0 ? comp.weight / cpmkCount : 0;

          const baseObject = {
            name: EncodeURIComponentSafe(comp.name),
            type: EncodeURIComponentSafe(typeValue),
            topic: EncodeURIComponentSafe(comp.topic),
            weight: comp.weight,
            obe: comp.cpmk.map((c) => {
              return {
                section_obe_id: c,
                weight_obe: weightPerCPMK,
              };
            }),
          };

          if (comp.ori === true) {
            baseObject.wg_com_id = comp?.wg_com_id || 0;
          }

          return baseObject;
        }),
        section_id: section_id,
      };

      console.log("Data to save:", param_append);
      const results = await CREATE_APPEND_SECTION_COM2(param_append);
      if (results.data && Object.values(results.data).length > 0) {
        HandlerProgressBar();
      } else {
        setsupmit({
          loading: false,
          data: [],
          message: results?.message || "Failed to save assessment. ",
        });
        openModal({ message: <MessageFailedScore message={results?.message || "Failed to save assessment. "} /> })
      }
    } catch (error) {
      console.error("Error saving assessment:", error);
      setsupmit({
        loading: false,
        data: [],
        message: "Failed to save assessment." + error?.message,
      });
      openModal({
        message: (
          <MessageFailedScore
            message={
              "Failed to save assessment. Please try again. " + error?.message
            }
          />
        ),
      });
    }
  };

  const RenderMessagePrerequisite = ({ messages }) => {
    return (
      <ul className="mb-0 pl-0" style={{ listStyle: "none" }}>
        {messages.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className="table-responsives">
      <table className="table table-head-bg table-bordered table-vertical-center">
        <thead>
          <tr className="text-left text-dark text-uppercase">
            <th width="20%">Name</th>
            <th width="15%">Type <sup className="text-danger">*</sup></th>
            <th width="15%">Topic <sup className="text-danger">*</sup></th>
            <th width="20%">CPMK <sup className="text-danger">*</sup></th>
            <th width="8%">Weight <sup className="text-danger">*</sup></th>
            <th width="5%"></th>
          </tr>
        </thead>
        <tbody>
          {my_comp && my_comp.length > 0 ? (
            my_comp.map((item, index) => (
              <tr key={index} className={!item.ori ? "bg-light-primary" : ""}>
                <td>
                  <span className="text-dark">
                    {item?.name}
                  </span>
                </td>
                <td>
                  {item?.ori ? item?.item_com_old ? item?.type?.value : item?.type?.label : (
                    <Select2TypeCom
                      data={type_com}
                      value={item.type}
                      setValue={(value) =>
                        handleUpdateComponent(item.id, "type", value)
                      }
                    />
                  )}
                </td>
                <td>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${!item.topic || item.topic.trim().length === 0 || item.topic.trim().length < 3
                      ? "is-invalid"
                      : ""
                      }`}
                    placeholder="Description"
                    value={item.topic}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Hanya update jika kosong atau minimal 3 karakter
                      if (value.length === 0 || value.length >= 3) {
                        handleUpdateComponent(item.id, "topic", value);
                      } else {
                        // Tetap update state tapi tampilkan error visual
                        handleUpdateComponent(item.id, "topic", value);
                      }
                    }}
                  />
                </td>
                <td>
                  <Select2CPMK
                    arr_data={section_cpmk}
                    data={item.cpmk}
                    isMulti={true}
                    setData={(value) =>
                      handleUpdateComponent(item.id, "cpmk", value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="0"
                    value={item.weight}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Backspace" ||
                        e.key === "Delete" ||
                        e.key === "Tab" ||
                        e.key === "Escape" ||
                        e.key === "Enter" ||
                        e.key === "ArrowLeft" ||
                        e.key === "ArrowRight" ||
                        e.key === "ArrowUp" ||
                        e.key === "ArrowDown"
                      ) {
                        return;
                      }
                      // Cegah input jika bukan angka 0-9
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pasteData = e.clipboardData.getData("text");
                      if (!/^\d+$/.test(pasteData)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      handleUpdateComponent(
                        item.id,
                        "weight",
                        parseInt(e.target.value) || 0,
                      )
                    }
                  />
                </td>
                <td className="text-center">
                  <ToolTip title={"Remove"} position="top">
                    <button
                      className="btn btn-icon btn-sm"
                      type="button"
                      onClick={() => item?.ori ? 
                        openModal({
                          message: (
                            <PopUpMessage
                              title={`Confirmation`}
                              type={"warning"}
                              message={`Deleting this assessment will permanently remove all scores you have entered. Do you want to proceed?`}
                              onAction={() => handleRemoveComponent(item.id)}
                            />
                          ),
                        }) : handleRemoveComponent(item.id)
                      }
                    >
                      <i className="fas fa-trash-alt text-danger"></i>
                    </button>
                  </ToolTip>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center text-muted">
                No components found. Click "Add New Assessment" to start.
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={6}>
              <div className="d-flex align-items-center justify-content-between">
                <button
                  className="btn btn-sm btn-light"
                  type="button"
                  onClick={handleAddNewComponent}
                >
                  <i className="fas fa-plus mr-1"></i> Add New Assessment
                </button>

                <div className="font-weight-bolder">
                  Total Weight :{" "}
                  <span
                    className={TotalWeight === 100 ? "text-primary" : "text-danger"}
                  >
                    {TotalWeight}%
                  </span>
                  <i
                    className={`fas fa-${TotalWeight === 100 ? "check-circle" : "times-circle"} ml-1 text-${TotalWeight === 100 ? "success" : "danger"}`}
                  ></i>
                </div>
              </div>
            </td>
          </tr>
          {message_required && message_required.length > 0 && (
            <tr>
              <td colSpan={6}>
                <div
                  className={`alert alert-custom alert-light-danger fade show`}
                  role="alert"
                >
                  <div className="alert-icon">
                    <i className="flaticon-warning"></i>
                  </div>
                  <div className="alert-text d-flex flex-column">
                    <h5 className="mb-1">Prerequisites Validation</h5>
                    <RenderMessagePrerequisite messages={message_required} />
                  </div>
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td colSpan={6} className="text-right border-0">
              <div className="btn btn-group">
                <button
                  className="btn btn-lg btn-light font-weight-bolder"
                  type="button"
                  onClick={() => HandlerBack()}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-lg btn-primary font-weight-bolder"
                  type="button"
                  disabled={
                    my_comp.length === 0 ||
                    TotalWeight !== 100 ||
                    Object.values(message_required).length !== 0 ||
                    supmit.loading
                  }
                  onClick={handleSaveChanges}
                >
                  {supmit.loading ? "Processing..." : "Save Changes"}
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}


const RemoveComponents = (components) => {

}